const url = process.env.REACT_APP_DOMINA_URL;
// const urlAlfa = process.env.REACT_APP_DOMINA_URL_ALFA;

const serviceRoutes = {
  // descargarFactura: "DescargaFactura",
  descargarFactura: "descargaFacturaService",
  reenviarCorreo: "reenviarCorreoService",
  creacionEmisor: "CreacionEmisoresService/",
  registrarResolucion: "RegistrarResoluciones",
};

function getHeaders(token) {
  return {
    "Content-Type": "application/json",
    Authorization: token,
  };
}

export const descargarFactura = async (body, token) =>
  await fetch(`${url}${serviceRoutes.descargarFactura}`, {
    method: "POST",
    headers: getHeaders(token),
    body: JSON.stringify(body),
  });

// export const descargarFactura = async (body, token) =>
//   await fetch(`${urlAlfa}${serviceRoutes.descargarFactura}`, {
//     method: "POST",
//     headers: getHeaders(token),
//     body: JSON.stringify(body),
//     mode: "no-cors",
//   });

export const reenviarDocumento = async (body, token) =>
  await fetch(`${url}${serviceRoutes.reenviarCorreo}`, {
    method: "POST",
    headers: getHeaders(token),
    body: JSON.stringify(body),
  }).then((response) => response.json());

export const registrarResolucionDomina = async (body, token) =>
  await fetch(`${url}${serviceRoutes.registrarResolucion}/${body}`, {
    method: "GET",
    headers: { Authorization: token },
  }).then((response) => response.json());
